/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import {
  SNACKBAR_CLEAR,
  SNACKBAR_ERROR,
  SNACKBAR_INFO,
  SNACKBAR_SUCCESS,
  SET_VALIDATION_STATE,
} from "../actions/ui";
import { UIState } from "../init-state";

const languages = (state = UIState, { type, payload }) => {
  switch (type) {
    case SNACKBAR_SUCCESS:
      return {
        ...state,
        successSnackbar: payload,
      };

    case SNACKBAR_ERROR:
      return {
        ...state,
        errorSnackbar: payload,
      };

    case SNACKBAR_INFO:
      return {
        ...state,
        infoSnackbar: payload,
      };

    case SNACKBAR_CLEAR:
      return {
        ...state,
        successSnackbar: "",
        errorSnackbar: "",
        infoSnackbar: "",
      };

    case SET_VALIDATION_STATE:
      return {
        ...state,
        isValidationActive: payload,
      };

    default:
      return state;
  }
};

export default languages;
